<script setup lang="ts">
    import type { DashboardStatItem } from '@/types';
    import Icon from '@/components/Icon.vue';
    import { Link } from '@inertiajs/vue3';

    defineProps<{
        stat: DashboardStatItem;
    }>();
</script>

<template>
    <component
        :key="stat.description"
        class="flex w-full shrink-0 items-center gap-2 md:max-w-[200px] 2xl:shrink"
        :is="stat.href ? Link : 'div'"
        :href="stat.href"
    >
        <Icon
            :name="stat.icon"
            class="text-destructive size-6 shrink-0"
        />
        <div class="flex flex-col">
            <span class="text-lg leading-[1.2] font-medium">{{ stat.value }}</span>
            <span class="text-muted-foreground text-[10px] leading-none">
                {{ stat.description }}
            </span>
        </div>
    </component>
</template>
